import axios from 'axios';
import Cookies from 'js-cookie';

export const checkSession = async (User) => {
  const login = User.profile['custom:login'];
  const sid = Cookies.get('sid');

  if (!login || !sid) return new Promise((_, reject) => reject());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_AUTH_ENDPOINT}/session/check?login=${login}&sessionId=${sid}`
    );

    return response.data;
  } catch (e) {
    return e.response.data;
  }
};
